<template>

    <div v-if="Object.keys(options).length > 1"
         class="variant-select">

        <div v-for="(options, name) in visibleMultivariantOptions"
             :key="name"
             class="variant-wrapper">

            <div class="option-info">
                {{ name }}:
                <span class="option-info-selected">
                    {{ selectedOption(name) }}
                </span>
            </div>

            <div class="options">
                <div v-for="option in options"
                     class="option-select"
                     :class="getClass(name, option)"
                     role="button"
                     @click="changeOption(name, option.value)">

                    <div class="content">
                        <div v-if="option.image">
                            <img :src="option.image">
                        </div>
                        {{ option.value }}
                    </div>
                </div>
            </div>
        </div>

    </div>

</template>

<script>
    import ApiVariant from '../api/Variant'
    import { pickBy } from 'lodash'

    export default {
        name: 'product-multivariant-options',
        props: {
            options: Object,
            multivariantOptions: Object,
            selected: String,
            showPhantoms: {
                type: Boolean,
                default: false
            }
        },
        data () {
            return {
                multiSelect: {},
                availableOptions: {}
            }
        },
        computed: {
            visibleMultivariantOptions () {
                return pickBy(this.multivariantOptions, (_options, name) => this.filterMultivariantOptions(name))
            }
        },
        watch: {
            selected () {
                this.setOptions()
            }
        },
        mounted () {
            if (this.selected) this.setOptions()
        },
        methods: {
            filterMultivariantOptions(name) {
              for (let option of Object.entries(this.multivariantOptions)){
                if(option[0] == name && option[1].length > 0){
                  return true;
                }
              }
              return false
            },
            setOptions () {
                this.multiSelect = {...{}, ...this.options[this.selected]}
                this.availableOptions = {...{}, ...this.options}
                this.disableNotAvailableOptions()
            },
            getClass(name, option) {
                return {
                    active: this.selectedOption(name) == option['value'],
                    disabled: this.isDisabled(name, option['value']),
                    'option-img': option['image']
                }
            },
            clearSelection() {
                this.availableOptions = {...{}, ...this.options}
                for (let option in this.multiSelect) {
                    this.multiSelect[option] = ''
                }
            },
            selectedOption(name) {
                return this.multiSelect[name]
            },
            unselectOtherOptions (name) {
                for (let multiSelectName in this.multiSelect) {
                    if (multiSelectName === name) { continue }
                    this.multiSelect[multiSelectName] = ''
                }
            },
            changeOption(name, option) {
                if (this.isDisabled(name, option)) {
                    this.unselectOtherOptions()
                }

                this.multiSelect = {...{}, ...this.multiSelect}
                this.multiSelect[name] = this.multiSelect[name] == option ? '' : option

                this.disableNotAvailableOptions()
            },
            disableNotAvailableOptions() {
                let exactlyMatchedOptions = []
                let amountOfSelectedOptions = Object.values(this.multiSelect).filter(option => option.length > 0).length
                this.availableOptions = {...{}, ...this.options}

                if (amountOfSelectedOptions > 0) {

                    for (let selected in this.multiSelect) {
                        let filtered = {}
                        let options = {...{}, ...this.availableOptions}

                        if (this.multiSelect[selected].length > 0) {
                            for (let id in options) {
                                if (options[id][selected] == this.multiSelect[selected]) filtered[id] = options[id]
                            }
                        } else {
                            filtered = {...{}, ...this.availableOptions}
                        }
                        this.availableOptions = {...{}, ...filtered}
                    }

                    for (let variantId in this.availableOptions) {
                        if (amountOfSelectedOptions === Object.values(this.availableOptions[variantId]).length) {
                            exactlyMatchedOptions.push(variantId)
                        }
                    }
                }

                let ids = Object.keys(this.availableOptions)
                if (ids.length === 1) {
                    this.changeVariant(ids[0])
                    this.$emit('canAddToCart', true)
                } else if (exactlyMatchedOptions.length > 0) {
                    this.changeVariant(exactlyMatchedOptions[0])
                    this.$emit('canAddToCart', true)
                } else {
                    this.$emit('canAddToCart', false)
                }
            },
            isDisabled(name, value) {
                return Object.values(this.availableOptions).filter(option => option[name] == value).length === 0
            },
            fetchApiVariant(id) {
                ApiVariant.getVariant(id, { show_phantoms: this.showPhantoms })
                    .then(response => {
                        this.setVariantFromResponse(id, response)
                    })
                    .catch(error => {
                        if (error?.response?.status === 410) {
                            this.setVariantFromResponse(id, error.response)
                        } else {
                            console.log(error)
                        }
                    })
            },
            setVariantFromResponse (id, response) {
                this.$store.dispatch('productData/addVariant', response.data.data)
                this.$emit('changeVariant', {
                    selectedVariant: id,
                    selectedVariantSlug: this.$store.getters['productData/getSlug'](id)
                })
                this.$emit('loading', false)
            },
            fetchStoreVariant(id) {
                this.$emit('changeVariant', {
                    selectedVariant: id,
                    selectedVariantSlug: this.$store.getters['productData/getSlug'](id)
                })
                this.$emit('loading', false)
            },
            changeVariant(id) {
                if (this.selected != id) {
                    this.$emit('loading', true)
                    if (this.$store.getters['productData/variantExist'](id)) {
                        console.log("VARIANT - FETCH FROM STORE")
                        this.fetchStoreVariant(id)
                    } else {
                        console.log("VARIANT - FETCH FROM API")
                        this.fetchApiVariant(id)
                    }
                } else {
                    console.log('NOTHING CHANGED')
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import '@/../shared/assets/stylesheets/product-options';

    .variant-select {
        grid-row-gap: 40px;

        .option-select {
            &.active {
                &:hover {
                    border-color: $color-danger;
                }
            }

            &.disabled {
                color: #cccccc;

                -webkit-filter: grayscale(100%);
                -moz-filter: grayscale(100%);
                -o-filter: grayscale(100%);
                -ms-filter: grayscale(100%);
                filter: grayscale(100%);

                img {
                    -webkit-filter: grayscale(100%);
                    -moz-filter: grayscale(100%);
                    -o-filter: grayscale(100%);
                    -ms-filter: grayscale(100%);
                    filter: grayscale(100%);
                    opacity: 0.3;
                    color: red;
                }
            }

            &.option-img {
                .content {
                    font-size: 1.2rem
                }
            }

            .content {
                img {
                    max-width: 100px;
                    max-height: 70px;
                }
            }
        }
    }
</style>
